import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 7px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		text-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
		white-space: nowrap;
	}
`;

export { StyledContainer };
